import {BaseEntityParams} from "@ypa/types/base-entity";
import {MetricReportGroupStatusEnum} from "@ypa/enums/metric-report-group-status";
import {FormTypeEnum} from "@ypa/enums/form-type";

export class MetricReportGroupParams extends BaseEntityParams {
    formId?: number;
    status?: MetricReportGroupStatusEnum | MetricReportGroupStatusEnum[];
    formType?: FormTypeEnum | FormTypeEnum[];
}
